import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    paddingBottom: theme.spacing(1),
    transition: 'margin 0.4s ease',
  },
  text: {
    marginTop: `${theme.spacing(4)} !important`,
  },
  iconButton: {
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
    marginLeft: `${theme.spacing(2)} !important`,
    [theme.breakpoints.down('sm')]: {
      marginLeft: `${theme.spacing(1)} !important`,
    },
  },
}))
